import { useSEO } from '@/hooks/useSEO';
import PageNavbar from "@/components/feature/PageNavbar";
import Footer from "@/pages/home/components/Footer";
import KitchenHero from "./components/KitchenHero";
import KitchenOverview from "./components/KitchenOverview";
import KitchenOfferings from "./components/KitchenOfferings";
import KitchenProcess from "./components/KitchenProcess";
import KitchenGallery from "./components/KitchenGallery";
import KitchenInquiry from "./components/KitchenInquiry";

const SITE_URL = (import.meta.env.VITE_SITE_URL as string) || 'https://isman.co.ke';

const KITCHEN_SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Commercial Kitchen Design & Installation",
    "url": SITE_URL + "/commercial-kitchen",
    "description": "Professional commercial kitchen design, equipment supply and installation services in Nairobi, Kenya. Stainless steel fabrication, ventilation and catering equipment specialists.",
    "provider": {
      "@type": "LocalBusiness",
      "name": "ISMAN Engineering Company",
      "url": SITE_URL,
      "telephone": "+254724114555"
    },
    "areaServed": { "@type": "Country", "name": "Kenya" },
    "serviceType": "Commercial Kitchen Design"
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Home", "item": SITE_URL },
      { "@type": "ListItem", "position": 2, "name": "Commercial Kitchen", "item": SITE_URL + "/commercial-kitchen" }
    ]
  }
];

export default function CommercialKitchenPage() {
  useSEO({
    title: 'Commercial Kitchen Design & Installation Nairobi Kenya | ISMAN Engineering',
    description: 'Professional commercial kitchen design, equipment supply and installation in Nairobi Kenya. Stainless steel fabrication, ventilation systems and catering equipment — by ISMAN Engineering.',
    keywords: 'commercial kitchen design Kenya, commercial kitchen installation Nairobi, catering kitchen equipment Kenya, stainless steel kitchen Kenya',
    canonical: SITE_URL + '/commercial-kitchen',
    schema: KITCHEN_SCHEMA,
  });

  return (
    <div className="min-h-screen">
      <PageNavbar />
      <KitchenHero />
      <KitchenOverview />
      <KitchenOfferings />
      <KitchenProcess />
      <KitchenGallery />
      <KitchenInquiry />
      <Footer />
    </div>
  );
}
